export default __webpack_public_path__ + "static/media/Jamie.1c872f92.jpg";